__turbopack_context__.v({
  "col": "ThreeColumnStack-module-scss-module__cABgca__col",
  "col2": "ThreeColumnStack-module-scss-module__cABgca__col2",
  "col3": "ThreeColumnStack-module-scss-module__cABgca__col3",
  "col4": "ThreeColumnStack-module-scss-module__cABgca__col4",
  "container": "ThreeColumnStack-module-scss-module__cABgca__container",
  "wrapper": "ThreeColumnStack-module-scss-module__cABgca__wrapper",
});
